class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.mainSummary = this.querySelector("summary.header__main-item");
    this.mainContent = this.querySelector("div.list-menu--disclosure");

    this.mainSummary.addEventListener("mouseover", this.onMouseOver.bind(this));
    this.mainSummary.addEventListener("mouseout", this.onMouseOut.bind(this));

    this.mainContent.addEventListener("mouseover", this.onMouseOver.bind(this));
    this.mainContent.addEventListener("mouseout", this.onMouseOut.bind(this));
  }

  onMouseOver() {
    this.mainDetailsToggle.setAttribute("open", "");
    // document.body.classList.add("overflow-hidden");
  }

  onMouseOut() {
    this.mainDetailsToggle.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    const globalOverlay = document.body.querySelector("#GlobalOverlay");
    const header = document.body.querySelector(".header");

    const isOpen = this.mainDetailsToggle.hasAttribute("open");

    globalOverlay.classList.toggle("d-none", !isOpen);
    // header.classList.toggle("bg-white", isOpen);
    // header.classList.toggle("bg-blur", !isOpen);

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);
